import { CONTACT_FORM_URL, PRIVACY_POLICY_URL } from "../../lib/mentoUrls";

interface Props {
  recipientNames: readonly string[];
}

/**
 * ステークホルダーの回答者に、枠を選ぶ前に「誰について語るのか」を示す。
 *
 * 従業員インタビューの予約ページには無いブロック。回答者は社外の上司にあたり、
 * 何のインタビューなのかをこの画面で理解できないと予約に進めない。
 */
export function StakeholderInterviewNotice({ recipientNames }: Props) {
  if (recipientNames.length === 0) return null;

  return (
    <section className="mb-6 rounded-xl border border-[var(--color-border-default)] bg-white p-6 shadow-[0_2px_8px_rgba(0,0,0,0.05)]">
      <h2 className="mb-3 font-bold text-[var(--color-text-primary)] text-lg">
        このインタビューについて
      </h2>
      <p className="mb-4 text-[var(--color-text-secondary)] text-sm">
        下記のみなさまについてお話をうかがいます。
        <br />
        1回のインタビューでまとめてお聞きします。ご予約は1枠のみで結構です。
      </p>
      <ul className="mb-4 flex flex-wrap gap-2 p-0">
        {recipientNames.map((name) => (
          <li
            key={name}
            className="list-none rounded-lg border border-[#b3d9f0] bg-[var(--color-primary-50)] px-3 py-1.5 font-medium text-[13px] text-[var(--color-primary-500)]"
          >
            {name} さん
          </li>
        ))}
      </ul>
      <p className="mb-2 text-[13px] text-[var(--color-text-secondary)]">
        お話しいただいた内容は、文字起こしと分析ののち、実名にて関係者に共有されます。
      </p>
      <p className="text-[13px] text-[var(--color-text-secondary)]">
        本インタビューは
        <a
          href={PRIVACY_POLICY_URL}
          target="_blank"
          rel="noreferrer"
          className="text-[var(--color-primary-500)] underline hover:no-underline"
        >
          プライバシーポリシー
        </a>
        に従い実施いたします。ご不明点は
        <a
          href={CONTACT_FORM_URL}
          target="_blank"
          rel="noreferrer"
          className="text-[var(--color-primary-500)] underline hover:no-underline"
        >
          お問い合わせフォーム
        </a>
        よりご連絡いただけます。
      </p>
    </section>
  );
}
